export default __webpack_public_path__ + "locales/bg/ResetApplicationDialog.json?hash=6ba575c1a5e4deae7eb1045e7c0aaac6";